import { motion } from "framer-motion";
import { useMarketingImage } from "@/lib/marketingAssets";
import partnerHero from "@/assets/landing/partner-img.jpg";

type PartnerAuthBrandPanelProps = {
  eyebrow?: string;
  title: string;
  subtitle?: string;
};

const PartnerAuthBrandPanel = ({
  eyebrow = "Partner workspace",
  title,
  subtitle,
}: PartnerAuthBrandPanelProps) => {
  const heroSrc = useMarketingImage("partners.brand.image", partnerHero);
  return (
    <div className="relative lg:w-[52%] bg-skutopia-600 text-white overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-skutopia-700/80 via-skutopia-600/70 to-skutopia-800/85" />

      <div className="relative z-10 flex flex-col min-h-[44vh] lg:min-h-screen p-8 sm:p-12 lg:p-14">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.65, ease: [0.22, 1, 0.36, 1] }}
          className="flex flex-col"
        >
          <p className="text-white/90 text-xs sm:text-sm font-medium tracking-[0.22em] uppercase mb-4">
            {eyebrow}
          </p>
          <h1 className="text-2xl sm:text-3xl lg:text-4xl font-semibold leading-tight tracking-tight mb-4 max-w-md">
            {title}
          </h1>
          {subtitle ? (
            <p className="text-base sm:text-lg text-white/75 leading-relaxed max-w-md mb-8">
              {subtitle}
            </p>
          ) : null}

          <div className="flex justify-center lg:justify-start mt-2">
            <motion.img
              initial={{ opacity: 0, y: 24, scale: 0.98 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              transition={{ duration: 0.75, delay: 0.12, ease: [0.22, 1, 0.36, 1] }}
              src={heroSrc}
              alt="Partner workspace preview on Skutopia Discover"
              className="w-full max-w-[520px] lg:max-w-none lg:w-[92%] rounded-2xl shadow-2xl shadow-black/25 ring-1 ring-white/15 object-cover"
            />
          </div>
        </motion.div>

        <p className="mt-auto pt-8 lg:pt-10 text-xs text-white/45">
          © {new Date().getFullYear()} Skutopia. Partner workspace for high school opportunities.
        </p>
      </div>
    </div>
  );
};

export default PartnerAuthBrandPanel;
